import ResellerUsersPage from './components/finance/Reaseller/ResellerUsersPage';
import AddResellerUserPage from './components/finance/Reaseller/AddResellerUserPage';
import TransactionsPage from './components/finance/TransactionsPage';
import VoucherBatchesPage from './components/finance/VoucherBatchesPage';
import PaymentsPage from './components/finance/PaymentsPage';
import PaymentDetailPage from './components/finance/PaymentDetailPage';
import InitiatePaymentPage from './components/finance/InitiatePaymentPage';
import PaymentMethodsPage from './components/finance/PaymentMethodsPage';

import ReportPage from './components/ReportPage';
import ShowMemberPage from './components/members/ShowMemberPage';
import MembersPage from './components/members/MembersPage';
import AddLearnPage from './components/learn/AddLearnPage';
import EditLearnPage from './components/learn/EditLearnPage';
import LearnsPage from './components/learn/LearnsPage';
                    
import { useState } from 'react';
import './App.css';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import DashboardHome from './components/DashboardHome';

import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import LoginPage from './components/auth/LoginPage';


import { getLang } from './i18n';

import UserManagementPage from './components/superadmin/UserManagementPage';
import UserProfilePage from './components/superadmin/UserProfilePage';
import LegalConsultationsPage from './components/Consultations/LegalConsultationsPage';
import ConsultationReplyPage from './components/Consultations/ConsultationReplyPage';
import SupportPage from './components/SupportPage';
import SupportTicketPage from './components/SupportTicketPage';
import NotificationsPage from './components/NotificationsPage';

import AddUserPage from './components/superadmin/AddUserPage';

import AccountManagementPage from './components/finance/Accounts/AccountManagementPage';
import EditAccountPage from './components/finance/Accounts/EditAccountPage';
import ApiResponseViewer from './components/common/ApiResponseViewer';
import AccountTransactionsPage from './components/finance/Accounts/Transactions/AccountTransactionsPage';
import SlidersPage from './components/slider/SlidersPage';
import CreateSliderPage from './components/slider/CreateSliderPage';
import EditSliderPage from './components/slider/EditSliderPage';
import PackagesPage from './components/Packages/PackagesPage';
import AddPackagePage from './components/Packages/AddPackagePage';
import EditPackagePage from './components/Packages/EditPackagePage';
import AddResellerPage from './components/finance/Reaseller/AddResellerPage';
import EditResellerPage from './components/finance/Reaseller/EditResellerPage';
import ResellersPage from './components/finance/Reaseller/ResellersPage';
import ResellerDetailPage from './components/finance/Reaseller/ResellerDetailPage';

function RequireAuth({ children }) {
  const token = localStorage.getItem('access_token');
  if (!token) {
    return <Navigate to="/auth/login" replace />;
  }
  return children;
}

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(
    window.innerWidth >= 768 // Open sidebar on larger screens
      ? true
      : false
  );

  const handleSidebarToggle = () => setSidebarOpen((open) => !open);

  const lang = getLang();
  const isRTL = lang === "ar";
  const sidebarMargin = isRTL
    ? (sidebarOpen ? 'mr-16 md:mr-64' : 'mr-16')
    : (sidebarOpen ? 'ml-16 md:ml-64' : 'ml-16');
  return (
    <div className="min-h-screen transition-all duration-300 bg-gray-100 dark:bg-gray-950" dir={isRTL ? "rtl" : "ltr"}>
      <Routes>
        <Route
          path="/auth/login"
          element={
            <main className="flex-1 p-0 bg-gray-100">
              <LoginPage />
            </main>
          }
        />
        <Route
          path="*"
          element={
            <RequireAuth>
              <>
                <Sidebar open={sidebarOpen} onToggle={handleSidebarToggle} />
                <div className={`flex flex-col bg-white transition-all duration-300 ${sidebarMargin}`}>
                  <Header />
                  <main className="flex-1 p-0">
                    <Routes>
                      <Route path="admin/" element={<ApiResponseViewer/>} />
                      <Route path="admin/packages" element={<PackagesPage />} />
                      <Route path="admin/packages/new" element={<AddPackagePage />} />
                      <Route path="admin/packages/:id/edit" element={<EditPackagePage />} />
                      <Route path="/admin/legal-consultations/" element={<LegalConsultationsPage />} />
                      <Route path="/admin/legal-consultations/reply/:id" element={<ConsultationReplyPage />} />
                      <Route path="/admin/learns" element={<LearnsPage />} />
                      <Route path="/admin/learns/new" element={<AddLearnPage />} />
                      <Route path="/admin/learns/:id/edit" element={<EditLearnPage />} />
                      <Route path="/admin/members" element={<MembersPage />} />
                      <Route path="/admin/members/:id" element={<ShowMemberPage />} />
                      <Route path="/admin/users" element={<UserManagementPage />} />
                      <Route path="/admin/accounts" element={<AccountManagementPage />} />
                      <Route path="/admin/accounts/:id/edit" element={<EditAccountPage />} />
                      <Route path="/admin/sliders" element={<SlidersPage/>} />
                      <Route path="/admin/sliders/new" element={<CreateSliderPage />} />
                      <Route path="/admin/sliders/:id/edit" element={<EditSliderPage />} />
                      <Route path="/admin/report" element={<ReportPage />} />   
                      <Route path="/admin/accounts/:id/transactions" element={<AccountTransactionsPage/>} />
                      <Route path="/admin/users/:id/edit" element={<UserProfilePage />} />
                      <Route path="/admin/users/new" element={<AddUserPage />} />
                      <Route path="/admin/notifications" element={<NotificationsPage />} />
                      <Route path="/finance/resellers" element={<ResellersPage />} />
                      <Route path="/finance/resellers/new" element={<AddResellerPage />} />
                      <Route path="/finance/resellers/:id/edit" element={<EditResellerPage />} />
                      <Route path="/finance/resellers/:id" element={<ResellerDetailPage />} />
                      <Route path="/finance/resellers/:id/reseller-users" element={<ResellerUsersPage />} />
                      <Route path="/finance/resellers/:id/reseller-users/new" element={<AddResellerUserPage />} />
                      <Route path="/finance/transactions" element={<TransactionsPage />} />
                      <Route path="/finance/voucher-batches" element={<VoucherBatchesPage />} />
                      <Route path="/finance/payments" element={<PaymentsPage />} />
                      <Route path="/finance/payments/initiate" element={<InitiatePaymentPage />} />
                      <Route path="/finance/payments/:id" element={<PaymentDetailPage />} />
                      <Route path="/finance/payment-methods" element={<PaymentMethodsPage />} />
                    </Routes>
                  </main>
                </div>
              </>
            </RequireAuth>
          }
        />
       
      </Routes>
    </div>
  );
}

export default App;
